import React from "react";

import { faArrowDownArrowUp } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "src/design-system/Icon";
import { getSortIcon } from "src/utils/icons";

/** TanStack's `column.getIsSorted()` shape: a direction, or false when unsorted. */
export type SortDirection = "asc" | "desc" | false;

type SortableColumnHeaderProps = {
  children: React.ReactNode;
  /** Current sort state for this column. */
  sortDirection: SortDirection;
  /** Toggle handler (e.g. TanStack `column.getToggleSortingHandler()`). */
  onClick?: (event?: unknown) => void;
  dataLoc?: string;
  ref?: React.Ref<HTMLButtonElement>;
};

/**
 * A column header that toggles sorting on click and shows the active direction.
 * Presentational only — callers wire up the sort mechanism (client-side TanStack
 * or server-side) by passing `sortDirection` + `onClick`.
 */
export const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
  children,
  sortDirection,
  onClick,
  dataLoc,
  ref,
}) => {
  const icon = getSortIcon(sortDirection, faArrowDownArrowUp);

  return (
    <button
      ref={ref}
      className="flex items-center gap-1"
      data-loc={dataLoc}
      type="button"
      onClick={onClick}
    >
      {children}
      <Icon
        icon={icon}
        size="2xs"
        variant={sortDirection ? "active" : "default"}
      />
    </button>
  );
};
